import buttons from './buttons.json'
export default { buttons : buttons}